
const data =
{
  respuesta: [
    {
      TicketID: 'CrptCddn_2640517619e31cfe968f',
      idNEO: 23295,
      idEmpresa: 225,
      IdCIFEmpresa: 242,
      CIF: 'A08432338',
      IdPGN: 6,
      Estado: 'No leída',
      FechaPublicacion: '2021-11-24T00:00:00',
      FechaVista: '2021-11-24T13:08:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Ayuntamiento de Vinaròs',
      CIFTitular: 'A08432338',
      EstadoDescarga: '0',
      FechaHora: '2021-11-24T14:08:43.623',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'CrptCddn_2640517619e31cfe968f',
      idNEO: 23294,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 6,
      Estado: 'No leída',
      FechaPublicacion: '2021-11-24T00:00:00',
      FechaVista: '2021-11-24T13:08:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Ayuntamiento de Vinaròs',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-24T14:08:33.833',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123558308',
      idNEO: 23224,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-23T23:14:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-24T09:49:09.66',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123535724',
      idNEO: 23223,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-23T22:44:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-24T09:49:09.307',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: '125987182',
      idNEO: 23222,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 1,
      Estado: 'NO_LEIDA',
      FechaPublicacion: '2021-11-23T17:51:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2826000H',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-24T09:49:08.92',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123478664',
      idNEO: 23177,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-22T22:27:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-23T08:56:00.603',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123478679',
      idNEO: 23178,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-22T22:27:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-23T08:56:00.96',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123472815',
      idNEO: 23176,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-22T22:17:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-23T08:56:00.27',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: 'TGSS_123472676',
      idNEO: 23175,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 2,
      Estado: 'Sin acuse',
      FechaPublicacion: '2021-11-22T22:17:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2827003A',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-23T08:55:59.913',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    },
    {
      TicketID: '125932055',
      idNEO: 23174,
      idEmpresa: 238,
      IdCIFEmpresa: 319,
      CIF: 'B43396985',
      IdPGN: 1,
      Estado: 'NO_LEIDA',
      FechaPublicacion: '2021-11-22T16:47:00',
      FechaVista: '1998-12-31T23:00:00',
      FechaProgramada: '1999-12-31T23:00:00',
      FechaDescargaExterna: '1998-12-31T23:00:00',
      CIFEmisor: 'Q2826000H',
      CIFTitular: 'B43396985',
      EstadoDescarga: '0',
      FechaHora: '2021-11-23T08:55:59.57',
      FechaCambioEstado: '0001-01-01T00:00:00',
      UltimoError: null,
      ContadorErroresResueltos: 0
    }
  ],
  links: {
    first: 'https://gestionneopre.zerocoma.com/api/NEO/getneopublicadas?page=1&results=10',
    last: 'https://gestionneopre.zerocoma.com/api/NEO/getneopublicadas?page=177&results=10',
    prev: null,
    next: 'https://gestionneopre.zerocoma.com/api/NEO/getneopublicadas?page=2&results=10'
  },
  meta: {
    currentPage: 1,
    from: 1,
    lastPage: 177,
    links: [
      {
        url: 'https://gestionneopre.zerocoma.com/api/NEO/getneopublicadas?page=1&results=10',
        label: 'GetNeoPublicadas',
        active: true
      }
    ],
    path: '/api/NEO/getneopublicadas',
    perPage: 10,
    to: 10,
    total: 1770
  },
  blnError: false,
  codError: null,
  msgError: null
}

export default data
